import { Injectable } from '@angular/core';
import { FullAssetReview, Inspection } from './inspection.dto';
import { DivisionQuery, NO_LIMIT_SEARCH_PARAMS, QueryService, SearchResult } from '@damofire/data-commons';
import { ObservableAssetService } from '../asset/asset-observable.service';
import { ObservableInspectionService } from './inspection-observable.service';
import { combineLatest, Observable } from 'rxjs';

@Injectable()
export class InspectionReviewObservableService {
  protected readonly SEARCH_FIELDS = ['clientCode', 'section', 'description', 'notes[text]'];

  constructor(
    private readonly observableAssetService: ObservableAssetService,
    private readonly observableInspectionService: ObservableInspectionService,
  ) {}

  getReviews(inspectionWithoutReviews: Inspection, query: DivisionQuery): Observable<SearchResult<FullAssetReview>> {
    return new Observable<SearchResult<FullAssetReview>>((observer) => {
      const assetSub = this.observableAssetService.search(
        inspectionWithoutReviews.division._id,
        { ...query, ...NO_LIMIT_SEARCH_PARAMS, searchPhrase: null },
        inspectionWithoutReviews._id,
      );
      const inspectionSub = this.observableInspectionService.observeInspection(inspectionWithoutReviews.division._id, inspectionWithoutReviews._id);

      const mergedSub = combineLatest([assetSub, inspectionSub]).subscribe(([assets, inspection]) => {
        const fullReviews: FullAssetReview[] = [];
        if (assets?.result.length && inspection) {
          assets.result.forEach((asset) => {
            const reviewMatch = inspection.reviews?.find((review) => review._id === asset._id);
            if (reviewMatch) {
              fullReviews.push({ ...reviewMatch, ...asset });
            }
          });
        }

        observer.next(QueryService.searchCollection<FullAssetReview>(fullReviews, query, this.SEARCH_FIELDS));
      });

      observer.add(mergedSub);
    });
  }
}
